const EmptyComp = ({ title, description, icon }) => {
  return (
    <div className="flex flex-col items-center justify-center w-11/12 gap-2 mx-auto my-4 sm:my-8 py-[15vh]">
      {icon || ""}
      {title ? (
        <h1 className="max-sm:mt-4 text-lg sm:text-2xl text-[#77458F] font-semibold text-center">
          {title}
        </h1>
      ) : null}
      {description ? (
        <p className="text-center text-zinc-600 max-w-96 max-sm:text-sm">
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default EmptyComp;
